<template>
  <router-view />
</template>

<script>
export default {
  name: "duty-management",
  components: {},
};
</script>
